import React, { useEffect, useMemo, useRef, useState } from 'react';
import Modal from '../../common/modal/Modal';
import Button from 'devextreme-react/button';
import icons from '../../common/icons/icons';
import ScrollView from 'devextreme-react/scroll-view';
import { FormProvider, useForm } from 'react-hook-form';
import ConfirmDialog from '../../common/confirm/ConfirmDialog';
import ValidationGroup from 'devextreme-react/validation-group';
import { IModalConfig } from '../../../types/modal';
import { useTranslation } from 'react-i18next';
import { IFleetVesselForm, IFleetVesselObject } from '../../../types/list';
import { IDialogConfig } from '../../../types/dialog';
import toast from '../../../utils/toast';
import FleetVesselFormFields from '../fleet-vessel-form/FleetVesselFormFields';
import { MarsApiConfig as apiConfig } from '../../../api/mars-api-config';
import { useLoaderContext } from '../../../contexts/LoaderContext';
import { MarsApiService as api } from '../../../api/mars-api-service';
import { ILiveVesselData } from '../../../types/live-vessel-data';

export default function EditFleetVessel(props: {
  isVisible: any;
  setIsVisible: any;
  fleetId: any;
  getFleetById: any;
}) {
  const [vesselIMO, setVesselIMO] = useState('');
  const [vesselData, setVesselData] = useState<ILiveVesselData | null>(null);
  const { setIsLoading } = useLoaderContext();
  const [confirmSaveDialog, setConfirmSaveDialog] = useState(false);
  const { t } = useTranslation();
  const { isVisible, setIsVisible, fleetId, getFleetById } = props;
  const [fleetVesselFormValue, setFleetVesselFormValue] =
    useState<IFleetVesselForm>({
      vesselIMO: '',
      vesselName: '',
      active: false,
    });
  const defaultFleetVesselValues: IFleetVesselForm = {
    vesselIMO: '',
    vesselName: '',
    active: true,
  };
  const fleetVesselForm = useForm({
    defaultValues: defaultFleetVesselValues,
  });
  const validationGroup: any = useRef();
  const modalConfig: IModalConfig = {
    width: 738,
    height: vesselData ? 310 : 210,
    visible: isVisible,
    showTitle: false,
    closeOnOutsideClick: false,
  };
  const popupAttributes = useMemo(() => {
    return {
      id: 'elementId',
      class: 'm-l-modal-main__wrap m-l-add-new-modal',
    };
  }, []);

  const handleCancelClick = () => {
    setIsVisible(false);
    fleetVesselForm.reset(defaultFleetVesselValues);
    setVesselData(null);
  };
  const handleSaveClick = (e: any) => {
    const requiredValidation = validationGroup.current.instance.validate();
    if (requiredValidation.isValid) {
      const allValues = fleetVesselForm.getValues();

      const fleetVesselData = {
        vesselIMO: allValues.vesselIMO,
        vesselName: allValues.vesselName,
        active: allValues.active,
      };
      setFleetVesselFormValue(fleetVesselData);
      setConfirmSaveDialog(true);
    }
  };
  const confirmSaveDialogConfig: IDialogConfig = {
    id: 'confirmSave',
    handleSubmit: async () => {
      setConfirmSaveDialog(false);
      //onSaveFleetVessel(fleetVesselFormValue);
      onSaveFleetVessel(vesselIMO);
    },
    handleClose: () => {
      setConfirmSaveDialog(false);
    },
  };
  const onSaveFleetVessel = (vesselIMO: string) => {
    const fleetVesselObject: IFleetVesselObject = {
      fleetId: fleetId,
      imonumber: vesselIMO,
      active: true,
    };
    saveVesselToFleetList(fleetVesselObject);
  };
  const saveVesselToFleetList = async (
    fleetVesselObject: IFleetVesselObject
  ) => {
    setIsVisible(false);
    await api
      .post(
        { url: apiConfig.fleetVesselList, data: fleetVesselObject },
        setIsLoading
      )
      .then(() => {
        getFleetById();
        toast.success({
          title: t('toast.fleetVesselAddedSuccess'),
        });
      });
  };

  return (
    <div className="inner-wrapper">
      <Modal modalConfig={modalConfig} wrapperAttr={popupAttributes}>
        <div className="m-l-modal__header">
          <h2 className="modal-title"> {t('headers.addVessel')}</h2>
          <div className="m-l-modal-close-button-block">
            <Button
              className="app-c-btn app-c-icon-only-btn"
              onClick={handleCancelClick}
            >
              <icons.IconCross />
            </Button>
          </div>
        </div>
        <div className="m-l-modal__body">
          <div className="m-l-adnw-form-panel">
            <FormProvider {...fleetVesselForm}>
              <ValidationGroup ref={validationGroup}>
                <FleetVesselFormFields
                  onVesselIMOChange={setVesselIMO}
                  onVesselDataChange={(data) => {
                    setVesselData(data);
                  }}
                />
              </ValidationGroup>
            </FormProvider>
          </div>
        </div>
        {vesselData && (
          <div className="m-l-modal__footer">
            <Button
              className="app-c-btn app-c-btn--primary"
              onClick={handleSaveClick}
            >
              {t('buttons.save')}
            </Button>
          </div>
        )}
      </Modal>
      <ConfirmDialog
        dialogConfig={confirmSaveDialogConfig}
        isOpen={confirmSaveDialog}
      />
    </div>
  );
}
